module.exports = __webpack_public_path__ + "static/media/bootstrap.47eb3019.svg";